<template>
	<div class="mb-0">
		<template v-if="inspector">
			<component :is="inspector" :parameters="testParameters"/>
		</template>
		<template v-else>
			<div class="d-flex" style="min-height:7rem">	
				<icon name="gears" class="m-auto" style="font-size:3em; opacity:0.4"/>
			</div>
		</template>
	</div>
</template>

<script>

	import SART from "./inspectors/sart";

	const TypeEditors = {
		SART
	};

	const ParamFactories = {
		SART(){
			return {
				stimulus:0.1,
				targetValue:1,
				values:100,
				displayTime:100,
				pause:1000
			}
		}
	};

	export default {
		props:{
			"data":Object
		},
		components:{
	
		},
		computed:{
			testParameters(){
				return this.data.testParameters;
			},
			inspector(){
				var type = this.data.testType;
				return type ? TypeEditors[type] : null; 
			}
		},
		watch:{
			"data.testType"(v){
				let fn = v ? ParamFactories[v] : null;
				this.data.testParameters = fn ? fn() : null;
			}
		},
		data(){
			return {
		
			}
		}
	}
</script>

<style>

</style>